import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { StyledInfo } from './styled-components'

const MODULE = 'subscriptionForm:fidelity_maximizer_module'

export interface LegacyPathCardProps {
  hidden: boolean
  copyKey: string
  disabled: boolean
  loading: boolean
  onClick: () => void
}

const LegacyPathCard = ({ hidden, copyKey, disabled, loading, onClick }: LegacyPathCardProps) => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }

  return (
    <>
      <SDNotification
        type='info'
        border
        primaryText={`<strong>${t(`${MODULE}.${copyKey}.card_title`)}</strong><br />${t(`${MODULE}.${copyKey}.script`)}`}
      >
        {/* @ts-ignore */}
        <SDButton block={true} disabled={disabled} isLoading={loading} onClick={onClick}>
          {t(`${MODULE}.${copyKey}.cta`)}
        </SDButton>
      </SDNotification>
      <StyledInfo $pulse={isPulse}>{t(`${MODULE}.${copyKey}.info`)}</StyledInfo>
    </>
  )
}

export default LegacyPathCard
